export default "__VITE_ASSET__C2M4bHck__"